var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.786 3.78L12.15.209c-.068-.067-.149-.12-.237-.155C11.825.018 11.73 0 11.636 0H2.182C.977 0 0 .96 0 2.143v15.714C0 19.041.977 20 2.182 20h11.636C15.023 20 16 19.04 16 17.857V4.286c-.001-.19-.078-.371-.214-.506zm-3.422-1.341l1.153 1.132h-1.153V2.44zm2.181 15.418c0 .395-.325.714-.727.714H2.182c-.402 0-.727-.32-.727-.714V2.143c0-.395.325-.714.727-.714h8.727v2.857c0 .394.326.714.727.714h2.91v12.857z",
    transform: "translate(-1623 -680) translate(1623 680)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.b2daca5f2bd90a78c29a77c4f72da02c.svg";
export { ForwardRef as ReactComponent };